import { GetStentorEventsProps, GetStentorEventsReturn } from "api";
import { Credentials } from "auth";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";

export type AdminFetchStentorEvents = "ADMIN_FETCH_STENTOR_EVENTS";
export const ADMIN_FETCH_STENTOR_EVENTS: AdminFetchStentorEvents = "ADMIN_FETCH_STENTOR_EVENTS";

export type AdminFetchStentorEventsEnd = "ADMIN_FETCH_STENTOR_EVENTS_END";
export const ADMIN_FETCH_STENTOR_EVENTS_END: AdminFetchStentorEventsEnd = "ADMIN_FETCH_STENTOR_EVENTS_END";

export interface AdminFetchStentorEventsAction extends Action {
    payload: {
        credentials: Credentials;
        props: GetStentorEventsProps;
    };
    type: AdminFetchStentorEvents;
}

export function fetchStentorEvents(
    props: GetStentorEventsProps
): ThunkAction<any, State, any, AdminFetchStentorEventsAction> {
    return (dispatch: Dispatch<AdminFetchStentorEventsAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(fetchStentorEventsWithCredentials(credentials, props));
    };
}

function fetchStentorEventsWithCredentials(
    credentials: Credentials,
    props: GetStentorEventsProps
): AdminFetchStentorEventsAction {
    return {
        payload: {
            credentials,
            props
        },
        type: ADMIN_FETCH_STENTOR_EVENTS
    };
}

export interface AdminFetchStentorEventsEndAction extends Action {
    payload: {
        error?: Error;
        returnValue?: GetStentorEventsReturn;
    };
    type: AdminFetchStentorEventsEnd;
}

export function fetchStentorEventsEnd(
    error?: Error,
    returnValue?: GetStentorEventsReturn
): AdminFetchStentorEventsEndAction {
    return {
        payload: {
            error,
            returnValue
        },
        type: ADMIN_FETCH_STENTOR_EVENTS_END
    };
}
